import { pushDataLayerForEvent } from '@lib/gtag';

// eslint-disable-next-line import/prefer-default-export
export const pageview = (url) => {
  pushDataLayerForEvent('pageview', { url });
};
